export default __webpack_public_path__ + "static/media/provi.e341b643.png";